<ng-container *ngIf="dataSource">
    <div class="flex flex-col items-start gap-4 py-4 md:border-bottom bg-white">
        <div class="flex w-full justify-between items-center">
            <div class="flex items-center gap-4">
                <h2 class="text-xl text-black font-bold">موقعیت مکانی</h2>
            </div>
          
            <a [href]="'https://www.iranhotelonline.com' + dataSource?.IhoMapUrl" (click)="runWebEngageApi()">
                <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex !pe-0"   >
                    <span class="text-blue-500 text-sm !font-medium">مشاهده واحد اقامتی روی نقشه</span>
                    <i class="ico-Left !text-2xl text-blue-500"></i>
                </button>
            </a>
        </div>
    
        <div class="h-[235px] w-full relative">
            <a [href]="'https://www.iranhotelonline.com' + dataSource?.IhoMapUrl"  (click)="runWebEngageApi()">
                <img [ngSrc]="dataSource!.IhoMapImage!" width="220" height="866" class="object-cover h-full w-full rounded-lg" alt="آدرس {{dataSource?.FullName}} روی نقشه">
            </a>
        </div>
    
        <div class="flex items-center gap-2 text-black-300">
            <i class="ico-Location text-[20px]"></i>
            <p>{{dataSource?.Address?.Address}}</p>
        </div>
    

    
        <a [href]="'https://www.iranhotelonline.com' + dataSource?.IhoMapUrl" >
            <button mat-button color="primary" class="icon-arrow-button md:!hidden" >
                <span>نمایش نقشه</span>
                <i class="ico-Left !text-2xl text-blue-500"></i>
            </button> 
        </a>
    </div>
</ng-container>